import React, { useMemo, useState, useRef, useEffect } from "react";
import Avatar from "../../components/Avatar";
import { BsThreeDotsVertical } from "react-icons/bs";
import DataTable from "../../components/DataTable";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { blockUser, fetchAllUsers } from "../../services/users";
import Spinner from "../../components/Spinner";
import StarRating from "../../components/TableTitle/StarRating";
import toast from "react-hot-toast";
import { TablePopup } from "../Requests/style";
import { PopupButton } from "../../components/Navbar/style";
import EditUserModal from "../../components/EditUser";
import { FaBan } from "react-icons/fa6";
import { FiEdit } from "react-icons/fi";

const Customer = () => {
  const columns = [
    "ID",
    "الاسم",
    "الصورة",
    "تاريخ الانتساب ",
    "رقم الهاتف",
    "الرحلات",
    "التقييم",
    "الرصيد",
    " ",
  ];

  const [showSettingPopup, setShowSettingPopup] = useState(false);
  const [popupPosition, setPopupPosition] = useState({ top: 0, right: 0 });
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const popupRef = useRef(null);

  const qc = useQueryClient();

  const blockMut = useMutation({
    mutationFn: (userId) => blockUser(userId),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["users", "all"] });
      toast.success("🚫 تم حظر المستخدم بنجاح");
      setShowSettingPopup(false);
    },
    onError: () => toast.error("❌ فشل في حظر المستخدم"),
  });

  const mapRows = (list) =>
    list.map((u, id) => {
      const validImg =
        u.profile_img && u.profile_img.startsWith("http")
          ? u.profile_img
          : `https://api.dicebear.com/7.x/initials/svg?seed=${encodeURIComponent(
              u.name
            )}&size=200&backgroundType=gradientLinear&fontWeight=500`;

      return [
        id + 1,
        u.name ?? "—",
        <Avatar key={`${u._id}-avatar`} img={validImg} />,
        u.created_at ? new Date(u.created_at).toLocaleDateString("ar-EG") : "—",
        u.phone_number ?? "—",
        u.totalTrips ?? "—",
        u.avgRating ? (
          <StarRating rating={u.avgRating} />
        ) : (
          <StarRating rating={0} />
        ),
        u.totalBalance ?? "—",
        <BsThreeDotsVertical
          key={`${u._id}-menu`}
          style={{ cursor: "pointer" }}
          onClick={(e) => {
            const rect = e.currentTarget.getBoundingClientRect();
            setPopupPosition({
              top: rect.bottom + window.scrollY + 25,
              right: window.innerWidth - rect.right - 37,
            });
            e.stopPropagation();
            setSelectedUserId(u._id);
            setShowSettingPopup(true);
          }}
        />,
        `/user-profile/${u._id}`,
      ];
    });

  const {
    data: users = [],
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ["users", "all"],
    queryFn: fetchAllUsers,
  });

  const rows = useMemo(() => mapRows(users), [users]);

  // Close popup when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (popupRef.current && !popupRef.current.contains(e.target)) {
        setShowSettingPopup(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  if (isLoading) return <Spinner />;
  if (isError) return <p>حدث خطأ: {error.message}</p>;
  if (!users || users.length === 0) return null;

  return (
    <>
      {showSettingPopup && (
        <TablePopup
          ref={popupRef}
          style={{
            position: "absolute",
            top: `${popupPosition.top}px`,
            right: `${popupPosition.right}px`,
            background: "#fff",
            borderRadius: "12px",
            boxShadow: "0 6px 20px rgba(0,0,0,0.15)",
            padding: "4px 0",
            zIndex: 200,
            minWidth: "180px",
          }}
        >
          <PopupButton
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              padding: "10px 15px",
              textAlign: "right",
              width: "100%",
              border: "none",
              background: "transparent",
              color: "#5cb85c",
              fontWeight: "bold",
              cursor: "pointer",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.background = "#e9f7ee")}
            onMouseLeave={(e) =>
              (e.currentTarget.style.background = "transparent")
            }
            onClick={() => {
              setShowSettingPopup(false);
              setShowEditModal(true);
            }}
          >
            <FiEdit /> تعديل الزبون
          </PopupButton>
          <div style={{ height: "1px", background: "#eee" }} />
          <PopupButton
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              padding: "10px 15px",
              textAlign: "right",
              width: "100%",
              border: "none",
              background: "transparent",
              color: "#d9534f",
              fontWeight: "bold",
              cursor: "pointer",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.background = "#fceaea")}
            onMouseLeave={(e) =>
              (e.currentTarget.style.background = "transparent")
            }
            onClick={(e) => {
              e.stopPropagation();
              blockMut.mutate(selectedUserId);
            }}
          >
            <FaBan /> حظر الزبون
          </PopupButton>
        </TablePopup>
      )}

      {showEditModal && selectedUserId && (
        <EditUserModal
          userId={selectedUserId}
          onClose={() => setShowEditModal(false)}
        />
      )}

      <DataTable columns={columns} data={rows} />
    </>
  );
};

export default Customer;
